import { type DbEvent, DbEventsResult } from '@apm/contracts';
import { toQuery } from '../api';
import { useQuery } from '../hooks/useQuery';

/**
 * DB 사건 조회 (9회차 결정 4).
 *
 * 사건은 드물어서 실시간으로 밀 이유가 없다. 화면에 들어올 때 한 번 읽고 새로고침으로 다시 읽는다.
 * 상세 화면(그 요청의 사건)과 DB 감시 탭(기간·종류)이 같은 훅을 쓴다.
 */

/** `GET /api/db/events` 응답. 봉투는 계약에 있다 (17회차) */
export type { DbEventsResult };

export interface DbEventsQuery {
  traceId?: string;
  kind?: string;
  from?: number;
  to?: number;
  limit?: number;
}

export interface DbEventsState {
  loading: boolean;
  rows: DbEvent[];
  total: number;
  /** 날짜 폴더 상한에 걸려 오래된 쪽을 못 봤다 */
  truncated: boolean;
  error?: string;
  reload: () => void;
}

export function useDbEvents(query: DbEventsQuery): DbEventsState {
  const { traceId, kind, from, to, limit } = query;
  const { loading, data, error, reload } = useQuery(
    `/api/db/events${toQuery({ traceId, kind, from, to, limit })}`,
    DbEventsResult,
  );
  return {
    loading,
    rows: data?.rows ?? [],
    total: data?.total ?? 0,
    truncated: data?.truncated === true,
    error,
    reload,
  };
}
